<template>
  <div style="height:100%">
        <div v-if="error">something went wrong</div>
        <div v-if="loading" style="z-index:9999;position: absolute;background: white;left: 0;right: 0;height: 0;bottom: 0;width: 100%;height: 100%;text-align: center;padding-top: 2rem;">
          <p class="mt-2">Generating document...</p>
        </div>
        <div id="invoice-container" v-show="!pdfUrl" style="position:relative;">
          <!-- Pages will be rendered here dynamically -->
        </div>
        <iframe v-if="pdfUrl" :src="pdfUrl" type="application/pdf" width="100%" height="100%">
          <p>Sorry, your browser doesn't support embedded PDFs.</p>
        </iframe>
  </div>
</template>

<script> 
import helper from "../../helper";
import html2pdf from 'html2pdf.js'
import axios from 'axios'
import { amountInWords } from '../../helpers/amountInWords'

// Document type translations
const documentTypeTranslations = {
  'fr': {
    'quote': 'Devis',
    'devis': 'Devis',
    'invoice': 'FACTURE',
    'purchase': 'BON DE COMMANDE',
    'order': 'BON DE COMMANDE',
    'reception': 'BON DE RECEPTION',
    'credit-invoice': "FACTURE D'AVOIR",
    'delivery': 'BON DE LIVRAISON',
    'return': "RETOUR",
    'payment': 'FACTURE'
  },
  "en": {
    "quote": "QUOTE",
    'devis': 'QUOTE',
    "invoice": "INVOICE",
    "purchase": "PURCHASE ORDER",
    "order": "PURCHASE ORDER",
    "reception": "RECEIVING NOTE",
    "credit-invoice": "CREDIT NOTE",
    "delivery": "DEL NOTE",
    "return": "RETURN",
    "payment": "INVOICE"
  },
  "ar": {
    "quote": "عرض سعر",
    "devis": "عرض سعر",
    "invoice": "فاتورة",
    "purchase": "أمر شراء",
    "order": "أمر شراء",
    "reception": "إشعار استلام",
    "credit-invoice": "إشعار ائتمان",
    "delivery": "إشعار تسليم",
    "return": "إرجاع",
    "payment": "فاتورة"
  }
}

// A4 page constants (in px at 96 DPI)
const PAGE_HEIGHT = 1120;
const PAGE_PADDING_TOP = 20;
const PAGE_PADDING_BOTTOM = 20;
const HEADER_HEIGHT = 260;        
const FOOTER_HEIGHT = 60;         
const TABLE_HEADER_HEIGHT = 45;   
const TABLE_ROW_HEIGHT = 35;      
const SUMMARY_HEIGHT = 200;       
const PAGE_NUMBER_HEIGHT = 25;    

export default {
  name: "ExternalInvoiceTemplate",
  data() {
    return {
      pdfUrl : null,
      template : null,
      type : 'invoice',
      documentType : 'invoice',
      business : null,
      item : null,
      error : null,
      logoBase64 : null,
      stampBase64: null,
      language : 'fr',
      dateFormat: 'YYYY-MM-DD',
      totalPages: 1,
      receiver: {},
      client: {},
      supplier: {}
    };
  },
  methods: {
    formatDiscountPercent(value) {
      return String(Math.round((parseFloat(value) || 0) * 100) / 100);
    },
    truncateClientName(value, maxLength = 35) {
      const name = String(value || '').trim();
      if (name.length <= maxLength) return name;
      return `${name.slice(0, maxLength - 3).trimEnd()}...`;
    },
    async generatePDF() {
      const element = document.getElementById('invoice-container');
      element.classList.add('generating-pdf');

      this.normalizeWatermarks(element);
      
      var imageTag = element.getElementsByTagName('img');
      for (var i = 0; i < imageTag.length; i++) {
        if (imageTag[i].classList.contains('electronic-stamp') || imageTag[i].classList.contains('electronic_stamp')) {
          if (this.stampBase64) imageTag[i].src = this.stampBase64;
        } else if (imageTag[i].classList.contains('logo')) {
          if (this.logoBase64) imageTag[i].src = this.logoBase64;
        } else {
          imageTag[i].src = await this.getBase64Image(imageTag[i].src);
        }
      }
      
      const pdfOptions = {
        margin: 0,
        filename: this.generateFileName(),
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 3 },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
      };

      if (this.totalPages > 1) {
        pdfOptions.pagebreak = { mode: ['css'] };
      }
    
      html2pdf().from(element).set(pdfOptions).outputPdf('blob').then(pdfBlob => {
        const pdfUrl = URL.createObjectURL(pdfBlob);
        this.loading = false;
        element.classList.remove('generating-pdf');
        window.location.href= pdfUrl;
      });
    },
    normalizeWatermarks(element) {
      const watermarkImages = element.querySelectorAll('img[data-filigrane="true"], img[alt="Filigrane"]');

      watermarkImages.forEach(image => {
        const wrapper = image.closest('[data-filigrane="true"]:not(img)') || image.parentElement;

        if (wrapper) {
          wrapper.style.setProperty('position', 'absolute', 'important');
          wrapper.style.setProperty('left', '0', 'important');
          wrapper.style.setProperty('right', '0', 'important');
          wrapper.style.setProperty('width', '100%', 'important');
          wrapper.style.setProperty('height', 'auto', 'important');
          wrapper.style.setProperty('overflow', 'hidden', 'important');
        }

        image.style.setProperty('display', 'block', 'important');
        image.style.setProperty('width', '100%', 'important');
        image.style.setProperty('max-width', '100%', 'important');
        image.style.setProperty('height', 'auto', 'important');
        image.style.setProperty('margin-left', 'auto', 'important');
        image.style.setProperty('margin-right', 'auto', 'important');
      });
    },
    generateFileName() {
      const docType = this.documentType.toLowerCase().replace(/\s+/g, '-');
      const ref = this.item.reference ? this.item.reference.replace(/\//g, '-') : '';
      const timestamp = new Date().getTime();
      return `${docType}-${ref}-${timestamp}.pdf`;
    },
    async getBase64Image(url) {
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        const reader = new FileReader();
        await new Promise((resolve, reject) => {
          reader.onload = resolve;
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
        return reader.result;
      } catch (error) {
        alert(error)
        return null
      }
    },
    async getTemplate() {
      try {
        const previewRoute = this.$route.path.startsWith('/mcp-preview/')
        const endpoint = previewRoute ? 'mcp-previews' : 'external-documents'
        const response = await axios.get(`${process.env.VUE_APP_API}/${endpoint}/${this.$route.params.id}`)
        this.business = response.data.business
        this.item = response.data.document
        if(response?.data?.lang){
          this.language = response?.data?.lang
        }

        if(this.business.currency){
          localStorage.setItem('currentCurrency',this.business.currency)
        }

        this.type = response.data.document_type || 'invoice'
        this.documentType = documentTypeTranslations[this.language][this.type] || this.type
        this.receiver = this.item.client || this.item.supplier || {};
        this.client = this.item.client || {};
        this.supplier = this.item.supplier || {};
        this.template = helper.jsonToHtml(JSON.parse(response.data.template.data));

        let templateMetadata = response.data.template.metadata;
        if (typeof templateMetadata === 'string') {
          try {
            templateMetadata = JSON.parse(templateMetadata);
          } catch (error) {
            templateMetadata = {};
          }
        }
        const supportedFormats = [
          'YYYY-MM-DD', 'YYYY/MM/DD', 'YYYY/DD/MM',
          'DD-MM-YYYY', 'DD/MM/YYYY', 'DD/YYYY/MM',
          'MM-DD-YYYY', 'MM/DD/YYYY', 'MM/YYYY/DD'
        ];
        if (templateMetadata && supportedFormats.includes(templateMetadata.date_format)) {
          this.dateFormat = templateMetadata.date_format;
        }
        if (this.business?.metadata?.date_format && supportedFormats.includes(this.business.metadata.date_format)) {
          this.dateFormat = this.business.metadata.date_format;
        }
      } catch (error) {
        this.error = error.message
        window.location.href = "https://gstocky.com"
        return null
      } finally {
        this.loading = false
      }
    },
    letterToNumbers(amount, explicitLang = null) {
      const lang = explicitLang || this.language || 'en';
      return amountInWords(amount, this.documentCurrency, lang);
    },
    formatDate(date) {
      return helper.formatDate(date, false, this.dateFormat);
    },
    formatMoney(number) {
      number = number ? number : 0;
      return helper.formatMoney(number, this.documentCurrency);
    },
    calculateProductsPerPage() {
      const usableFirstPage = PAGE_HEIGHT - PAGE_PADDING_TOP - PAGE_PADDING_BOTTOM - HEADER_HEIGHT - FOOTER_HEIGHT - TABLE_HEADER_HEIGHT - PAGE_NUMBER_HEIGHT;
      const usableNextPage = PAGE_HEIGHT - PAGE_PADDING_TOP - PAGE_PADDING_BOTTOM - FOOTER_HEIGHT - TABLE_HEADER_HEIGHT - PAGE_NUMBER_HEIGHT;

      const productsOnFirstPage = Math.floor(usableFirstPage / TABLE_ROW_HEIGHT);
      const productsOnNextPage = Math.floor(usableNextPage / TABLE_ROW_HEIGHT);

      return { productsOnFirstPage, productsOnNextPage };
    },
    paginateProducts() {
      const products = this.item.products || [];
      if (products.length === 0) return { pages: [[]], totalPages: 1 };

      const { productsOnFirstPage, productsOnNextPage } = this.calculateProductsPerPage();
      const summaryRows = Math.ceil(SUMMARY_HEIGHT / TABLE_ROW_HEIGHT);

      const pages = [];
      let remaining = [...products];

      const firstPageMaxWithSummary = Math.max(1, productsOnFirstPage - summaryRows);
      
      if (remaining.length <= firstPageMaxWithSummary) {
        pages.push(remaining);
        this.totalPages = 1;
        return { pages, totalPages: 1 };
      }

      const firstChunkSize = Math.min(remaining.length, productsOnFirstPage);
      pages.push(remaining.splice(0, firstChunkSize));

      while (remaining.length > 0) {
        const nextPageMaxWithSummary = Math.max(1, productsOnNextPage - summaryRows);
        
        if (remaining.length <= nextPageMaxWithSummary) {
          pages.push(remaining.splice(0));
        } else {
          const chunkSize = Math.min(remaining.length, productsOnNextPage);
          pages.push(remaining.splice(0, chunkSize));
        }
      }

      this.totalPages = pages.length;
      return { pages, totalPages: pages.length };
    },
    extractTemplateParts(formattedHtml) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = formattedHtml;

      const table = tempDiv.querySelector('.invoice-builder-table');
      const bottomPage = tempDiv.querySelector('.invoice-builder-bottom-page');

      let headerHtml = '';
      let summaryHtml = '';
      let footerHtml = '';
      let tableHeadHtml = '';
      let tableRowTemplateHtml = '';
      let tableResponsiveStyle = 'margin-top: 20px; min-height: 400px;';

      const tableResponsiveDiv = tempDiv.querySelector('.table-responsive');
      if (tableResponsiveDiv) {
        tableResponsiveStyle = tableResponsiveDiv.getAttribute('style') || tableResponsiveStyle;
      }

      const children = Array.from(tempDiv.children);
      for (const child of children) {
        if (child.querySelector('.table-responsive') || child.classList.contains('table-responsive')) {
          break;
        }
        headerHtml += child.outerHTML;
      }

      if (table) {
        const thead = table.querySelector('thead');
        if (thead) tableHeadHtml = thead.outerHTML;
        const tbody = table.querySelector('tbody');
        if (tbody) {
          const firstRow = tbody.querySelector('tr');
          if (firstRow) tableRowTemplateHtml = firstRow.outerHTML;
        }
      }

      let foundTable = false;
      for (const child of children) {
        if (child.querySelector('.table-responsive') || child.classList.contains('table-responsive')) {
          foundTable = true;
          continue;
        }
        if (foundTable) {
          if (child.querySelector('.invoice-builder-bottom-page') || child.classList.contains('invoice-builder-bottom-page')) {
            footerHtml = child.outerHTML;
          } else {
            summaryHtml += child.outerHTML;
          }
        }
      }

      if (!footerHtml && bottomPage) {
        footerHtml = bottomPage.closest('.row')?.outerHTML || bottomPage.outerHTML;
        if (summaryHtml.includes('invoice-builder-bottom-page')) {
          const summaryDiv = document.createElement('div');
          summaryDiv.innerHTML = summaryHtml;
          const footerInSummary = summaryDiv.querySelector('.invoice-builder-bottom-page');
          if (footerInSummary) {
            const footerRow = footerInSummary.closest('.row');
            if (footerRow) {
              footerRow.remove();
            } else {
              footerInSummary.remove();
            }
          }
          summaryHtml = summaryDiv.innerHTML;
        }
      }

      return { headerHtml, tableHeadHtml, tableRowTemplateHtml, summaryHtml, footerHtml, tableResponsiveStyle };
    },
    buildPageHtml(pageIndex, totalPages, products, parts, isFirstPage, isLastPage) {
      const { headerHtml, tableHeadHtml, summaryHtml, footerHtml, tableResponsiveStyle } = parts;

      let productRowsHtml = '';
      products.forEach((product, i) => {
        let globalIndex = i + 1;
        if (pageIndex > 0) {
          const { productsOnFirstPage, productsOnNextPage } = this.calculateProductsPerPage();
          globalIndex = productsOnFirstPage + 1;
          for (let p = 1; p < pageIndex; p++) {
            globalIndex += productsOnNextPage;
          }
          globalIndex += i;
        }

        const row = parts.tableRowTemplateHtml
          .replace("{product.index}", globalIndex)
          .replace("{product.label}", () => helper.sanitizeRichText(product.product_label || ''))
          .replace("{product.quantity}", product.quantity || '')
          .replace(/\{product\.unity\}/g, () => String(product.unity || ''))
          .replace(/\{product\.unit\}/g, () => String(product.unity || ''))
          .replace("{product.price}", this.formatMoney(product.price || '0'))
          .replace("{product.vat}", product.vat || '0')
          .replace("{product.sub_total}", this.formatMoney(product.sub_total || 0))
          .replace("{product.total}", this.formatMoney(product.total || 0));
        productRowsHtml += row;
      });

      const tableStyle = 'width: 100%; border-collapse: collapse; border: 1px solid rgb(229, 231, 235); border-radius: 8px; overflow: hidden;';
      const tableHtml = `
        <div class="table-responsive" style="${tableResponsiveStyle}">
          <table class="table invoice-builder-table" style="${tableStyle}">
            ${tableHeadHtml}
            <tbody>${productRowsHtml}</tbody>
          </table>
        </div>
      `;

      const pageNumberHtml = `
        <div class="invoice-page-number" style="text-align: center; font-size: 10px; color: #6b7280; padding: 5px 0;">
          ${pageIndex + 1}/${totalPages}
        </div>
      `;

      let pageFooterHtml = footerHtml || '';
      const bottomSection = `
        <div class="invoice-page-bottom" style="position: absolute; bottom: 0px; left: 0; right: 0; padding-bottom: 20px;">
          ${pageNumberHtml}
          ${pageFooterHtml}
        </div>
      `;

      const isPreview = this.item?.status === 'preview';
      const previewLabel = this.language === 'fr' ? 'APERÇU' : (this.language === 'ar' ? 'معاينة' : 'PREVIEW');
      const watermarkLabel = this.item.deleted_at
        ? (this.$t ? this.$t('deleted').toUpperCase() : 'DELETED')
        : (isPreview ? previewLabel : '');
      const watermarkColor = this.item.deleted_at ? 'rgba(255, 0, 0, 0.15)' : 'rgba(38, 103, 255, 0.12)';
      const watermarkHtml = watermarkLabel ? `
        <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(-45deg); font-size: 120px; color: ${watermarkColor}; font-weight: bold; pointer-events: none; white-space: nowrap; z-index: 9999;">
          ${watermarkLabel}
        </div>
      ` : '';

      let pageContent = watermarkHtml;
      
      if (isFirstPage) {
        pageContent += headerHtml;
      }
      
      pageContent += tableHtml;

      if (isLastPage) {
        pageContent += summaryHtml;
      }

      pageContent += bottomSection;

      const pageBreak = pageIndex < totalPages - 1 ? 'page-break-after: always;' : '';
      const pageHtml = `
        <div class="invoice-page" style="position: relative; width: 100%; height: ${PAGE_HEIGHT}px; padding: 40px; box-sizing: border-box; overflow: hidden; ${pageBreak} background: white; font-family: var(--document-font-family);">
          <div class="invoice-page-content" style="position: relative; height: 100%;">
            ${pageContent}
          </div>
        </div>
      `;

      return pageHtml;
    },
    renderPages() {
      if (!this.template || !this.item.products) return;

      const formattedHtml = this.formatTemplate();
      const parts = this.extractTemplateParts(formattedHtml);
      const { pages, totalPages } = this.paginateProducts();

      const container = document.getElementById('invoice-container');
      if (!container) return;

      let allPagesHtml = '';

      for (let i = 0; i < pages.length; i++) {
        const isFirst = i === 0;
        const isLast = i === pages.length - 1;
        allPagesHtml += this.buildPageHtml(i, totalPages, pages[i], parts, isFirst, isLast);
      }

      container.innerHTML = allPagesHtml;

      if (this.logoBase64 || this.business?.logo) {
        const logos = container.querySelectorAll('.logo');
        logos.forEach(logo => {
          logo.src = this.logoBase64 || this.business.logo || '';
        });
      }

      if (this.stampBase64 || this.business?.electronic_stamp) {
        const stamps = container.querySelectorAll('.electronic_stamp, .electronic-stamp');
        stamps.forEach(stamp => {
          stamp.src = this.stampBase64 || this.business.electronic_stamp || '';
        });
      }
    },
    hideEmptyProductUnitColumn(root) {
      if (this.business?.metadata?.show_product_unit !== true) return;

      const hasUnitValue = (this.item?.products || []).some(product =>
        product?.unity !== null &&
        product?.unity !== undefined &&
        String(product.unity).trim() !== ''
      );
      if (hasUnitValue) return;

      root.querySelectorAll('table').forEach(table => {
        let unitColumnIndex = -1;

        for (const row of table.querySelectorAll('tbody tr')) {
          const cells = Array.from(row.children);
          const index = cells.findIndex(cell => /\{product\.(?:unity|unit)\}/.test(cell.innerHTML));
          if (index !== -1) {
            unitColumnIndex = index;
            break;
          }
        }

        if (unitColumnIndex === -1) return;

        table.querySelectorAll('tr').forEach(row => {
          const cell = row.children[unitColumnIndex];
          if (cell) cell.remove();
        });

        const column = table.querySelectorAll('colgroup col')[unitColumnIndex];
        if (column) column.remove();
      });
    },
    formatTemplate() {
      if (!this.template) return '';
      const currentDocumentType = this.type.toLowerCase();
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = this.template;

      const elementsWithDisplayAttr = tempDiv.querySelectorAll('[data-invoicly-display]');
      elementsWithDisplayAttr.forEach(element => {
        const displayValue = element.getAttribute('data-invoicly-display');

        if(displayValue == ''){
          displayValue == 'always'
        }

        if (displayValue !== 'always') {
          const allowedTypes = displayValue.split(',').map(type => type.trim().toLowerCase());
          if (!allowedTypes.includes(currentDocumentType)) {
            element.remove();
          }
        }
      });

      this.hideEmptyProductUnitColumn(tempDiv);

      const discountCells = tempDiv.querySelectorAll('td');
      discountCells.forEach(td => {
        const isDiscountCell = td.innerHTML.includes('{total_discount}');
        const isNetHtCell = td.innerHTML.includes('{net_ht_after_discount}');
        if (!isDiscountCell && !isNetHtCell) return;

        const row = td.closest('tr');
        if (!row) return;

        if (this.totalDiscounts == 0) {
          row.remove();
          return;
        }

        const labelCell = Array.from(row.querySelectorAll('td, th')).find(cell => cell !== td);
        if (isDiscountCell && labelCell) {
          labelCell.appendChild(document.createTextNode(` (${this.formatDiscountPercent(this.discountPercent)}%)`));
        }
      });

      let formattedTemplate = tempDiv.innerHTML
        .replace(/{business.name}/g, this.business.name || '')
        .replace(/{business.logo}/g, this.business.logo || '')
        .replace(/{business.electronic_stamp}/g, this.business.electronic_stamp || '')
        .replace(/{business.currency}/g, this.documentCurrency)
        .replace(/{business.email}/g, this.business.email || '')
        .replace(/{business.address}/g, this.business.address || '')
        .replace(/{business.phone}/g, this.business.phone || '')
        .replace(/{business.website}/g, this.business.website || '')
        .replace(/{business.billing_info}/g, this.business.billing_info || '')  
        .replace(/{document.reference}/g, this.item.reference || '')
        .replace(/{document.date}/g, this.formatDate(this.item.date))
        .replace(/{{currency}}/g, this.documentCurrency)
        .replace(/\{letterToNumbers\(([^)]+)\)\}/g,(match, innerContent) => {
          const cleaned = innerContent.replace(/[{}"'\s]/g, '');
          const parts = cleaned.split(',');
          const variable = parts[0];
          const explicitLang = parts[1] || null;

          let value = 0;
          if (variable === 'total') value = this.totalPrice;
          else if (variable === 'sub_total') value = this.totalHtPrice;
          else if (variable === 'net_ht_after_discount') value = this.netHtAfterDiscount;
          else if (variable === 'total_tax') value = this.totalTvaPrice;
          else if (variable === 'total_discount') value = this.totalDiscounts;
          else if (variable.startsWith('client.')) value = this.client[variable.split('.')[1]] || 0;
          else if (variable.startsWith('supplier.')) value = this.supplier[variable.split('.')[1]] || 0;
          else if (variable.startsWith('receiver.')) value = this.receiver[variable.split('.')[1]] || 0;
          else if (!isNaN(Number(variable))) value = Number(variable);
          return this.letterToNumbers(value, explicitLang);
        })
        .replace(/{sub_total}/g, this.formatMoney(this.totalHtPrice))
        .replace(/{net_ht_after_discount}/g, this.formatMoney(this.netHtAfterDiscount))
        .replace(/{total}/g, this.formatMoney(this.totalPrice))
        .replace(/{total_tax}/g, this.formatMoney(this.totalTvaPrice))
        .replace(/{total_discount}/g, this.formatMoney(this.totalDiscounts))
        .replace(/{notes}/g, this?.item?.notes || '')
        .replace(/{client.name}/g, this.truncateClientName(this.client?.name))
        .replace(/{client.id}/g, this.client?.id || '')
        .replace(/{client.reference}/g, this.client?.reference || '')
        .replace(/{client.address}/g, this.client?.address || '')
        .replace(/{supplier.name}/g, this.supplier?.name || '')
        .replace(/{supplier.id}/g, this.supplier?.id || '')
        .replace(/{supplier.reference}/g, this.supplier?.reference || '')
        .replace(/{supplier.address}/g, this.supplier?.address || '')
        .replace(/{receiver.name}/g, this.item?.client
          ? this.truncateClientName(this.receiver?.name)
          : (this.receiver?.name || ''))
        .replace(/{receiver.reference}/g, this.receiver?.reference || '')
        .replace(/{receiver.address}/g, this.receiver?.address || '')
        .replace(/{receiver.city}/g, this.receiver?.city || '')
        .replace(/{receiver.vat_number}/g, this.receiver?.vat_number || '')
        .replace(/{document.type}/g, this.documentType)
        .replace(/{payment_term}/g, this.item?.payment_term || '')
        .replace(/{client_po_number}/g, this.item?.client_po_number || '')
        .replace(/{client_dn_number}/g, this.item?.client_dn_number || '')
        .replace(/{client_in_number}/g, this.item?.client_in_number || '')
        .replace(/#product_label#/g, this.$t ? this.$t('product_label') : 'Label')
        .replace(/#product_quantity#/g, this.$t ? this.$t('product_quantity') : 'Qty')
        .replace(/#product_unit_price#/g, this.$t ? this.$t('product_unit_price') : 'Unit Price')
        .replace(/#product_vat#/g, this.$t ? this.$t('product_vat') : 'VAT')
        .replace(/#product_total_ht#/g, this.$t ? this.$t('product_total_ht') : 'Total HT')
        .replace(/#subtotal#/g, this.$t ? this.$t('subtotal') : 'Subtotal')
        .replace(/#vat#/g, this.$t ? this.$t('vat') : 'VAT')
        .replace(/#discount#/g, this.$t ? this.$t('discount') : 'Discount')
        .replace(/#total#/g, this.$t ? this.$t('total') : 'Total')
        .replace(/#amount_in_words#/g, this.$t ? this.$t('amount_in_words') : 'Amount in words')
        .replace(/#date#/g, this.$t ? this.$t('date') : 'Date')
        .replace(/#u_p#/g, this.$t ? this.$t('u_p') : 'U.P') 
        .replace(/#sub_total#/g, this.$t ? this.$t('sub_total') : 'Sub total')
        .replace(/#net_ht_after_discount#/g, this.$t ? this.$t('net_ht_after_discount') : 'Net HT after discount')
        .replace(/#product_index#/g, this.$t ? this.$t('product_index') : 'N°')
        .replace(/#client_signature#/g, this.$t ? this.$t('client_signature') : 'Client signature')
        .replace(/#supplier_signature#/g, this.$t ? this.$t('supplier_signature') : 'Supplier signature')
        .replace(/#electronic_stamp#/g, this.$t ? this.$t('electronic_stamp') : 'Electronic stamp');

      if (this.business && this.business.extra_fields) {
        this.business.extra_fields.forEach(field => {
          formattedTemplate = formattedTemplate.replace(new RegExp(`{business.${field.field_name}}`, 'g'), field.field_value || '');
        });
      }

      formattedTemplate = formattedTemplate.replace(/{business\.[^}]*}/g, '');
      return formattedTemplate;
    }
  },
  computed: {
    documentCurrency() {
      return this.item?.currency || this.business?.currency || '$';
    },
    totalPrice() {
      const authoritative = this.item?.total;
      if (authoritative !== null && authoritative !== undefined && Number.isFinite(Number(authoritative))) return Number(authoritative);
      return this.item && this.item.products && this.item.products.length 
        ? this.item.products.reduce((acc, curr) => acc + (parseFloat(curr.total) || 0), 0)
        : 0;
    },
    totalHtPrice() {
      const authoritative = this.item?.sub_total;
      if (authoritative !== null && authoritative !== undefined && Number.isFinite(Number(authoritative))) return Number(authoritative);
      return this.item && this.item.products && this.item.products.length
        ? this.item.products.reduce((acc, curr) => acc + (parseFloat(curr.sub_total) || 0), 0)
        : 0;
    },
    totalDiscounts() {
      const authoritative = this.item?.total_discount;
      if (authoritative !== null && authoritative !== undefined && Number.isFinite(Number(authoritative))) return Number(authoritative);
      if (!this.item || !this.item.products) return 0;
      return this.item.products.reduce((total, product) => {
        if (product.discount) {
          return total + (parseFloat(product.sub_total) || 0) * (parseFloat(product.discount) / 100);
        }
        return total;
      }, 0);
    },
    netHtAfterDiscount() {
      return (parseFloat(this.totalHtPrice) || 0) - (parseFloat(this.totalDiscounts) || 0);
    },
    discountPercent() {
      const subTotal = parseFloat(this.totalHtPrice) || 0;
      const discount = parseFloat(this.totalDiscounts) || 0;
      return subTotal > 0 ? (discount / subTotal) * 100 : 0;
    },
    totalTvaPrice() {
      const authoritative = this.item?.total_vat;
      if (authoritative !== null && authoritative !== undefined && Number.isFinite(Number(authoritative))) return Number(authoritative);
      if (!this.item || !this.item.products) return 0;
      return this.item.products.reduce((total, product) => {
        const subTotal = parseFloat(product.sub_total) || 0;
        const discountRate = parseFloat(product.discount) || 0;
        return total + ((parseFloat(product.vat) || 0) / 100 * (subTotal - (subTotal * discountRate / 100)));
      }, 0);
    },
  },
  async created(){
    this.loading = true;
  },
  async mounted() {
    const browserLang = navigator.language ? navigator.language.split('-')[0] : 'en';
    this.language = ['fr', 'en', 'ar'].includes(browserLang) ? browserLang : 'en';

    await this.getTemplate()
    
    const isRTL = this.language === 'ar';
    document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
    
    const invoiceContainer = document.getElementById('invoice-container');
    if (invoiceContainer) {
      invoiceContainer.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
    }
    
    this.logoBase64 = this.business?.logo ? await this.getBase64Image(this.business.logo) : null;
    this.stampBase64 = this.business?.electronic_stamp ? await this.getBase64Image(this.business.electronic_stamp) : null;
    
    this.$nextTick(() => {
      this.renderPages();
      setTimeout(() => {
        this.generatePDF();
      }, 500);
    });
  }
};
</script>

<style scoped>
.invoice-page {
  font-family: var(--document-font-family);
  background: white;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  margin-bottom: 10px;
}
.generating-pdf .invoice-page {
  box-shadow: none !important;
  margin-bottom: 0px !important;
}

.invoice-page + .invoice-page {
  border-top: 2px dashed #ccc;
}
.generating-pdf .invoice-page + .invoice-page {
  border-top: none !important;
}

.invoice-builder-bottom-page {
    position: relative !important;
    padding-top:5px;
    left : 0 !important;
    right : 0 !important;
    width: 100% !important;
    padding: 5px 0;
}

.invoice-page-bottom {
  position: absolute !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
}

.invoice-page-number {
  font-family: inherit;
  color: #9ca3af;
  letter-spacing: 0.5px;
}
</style>
